import { Typography } from '@mui/material';
import { sharedStyles } from '../../utils/Style';

type TextColumnProps = {
  value: string;
};

export const TextColumn = (props: TextColumnProps) => {
  return (
    <Typography sx={sharedStyles.tableStringField}>{props.value}</Typography>
  );
};
